import React, { useEffect, useState } from "react";
import { BreadCrumb, CRUDTable } from "../../../Components";
import { HistoryUser } from "../../../Constants/dummy";
import { IoEyeOutline, IoPencil, IoTrashOutline } from "react-icons/io5";
import { useStateContext } from "../../../contexts/ContextProvider";
import Select from "react-select";
import { AiOutlineConsoleSql } from "react-icons/ai";

export const UserHistory = () => {
  const [data, setData] = useState(HistoryUser);
  const [teamData, setTeamData] = useState([]);
  const [teamId, setTeamID] = useState("");
  const [creator, setCreator] = useState("");
  const [history, setHistory] = useState([]);
  const { userType } = useStateContext();
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedZone, setSelectedZone] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState([]);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [users, setUsers] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const techPro = sessionStorage.getItem("TechPro");
  const ProTeam = sessionStorage.getItem("ProTeam");

  const apiUrl = 'https://lebontechnicien.net'

  const handleDataChange = (newData) => {
    setData(newData);
  };

  const handleZoneChange = (selectedOptions) => {
    setSelectedZone(selectedOptions);
  };

  const fetchData = async (type) => {
    try {
      const response = await fetch(`${apiUrl}/find`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ type }),
      });
      const users = await response.json();

      // Filter users where 'entreprise' is 'oui'
      const filteredUsers = users.filter((user) => user.entreprise === "oui");

      switch (type) {
        case "User":
          setUsers(filteredUsers.reverse());
          break;
        default:
          break;
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData("User");
  }, [inputValue]);

  console.log("ProTeam", ProTeam);
  console.log("userType", userType);

  // Fetches all the interventions
  useEffect(() => {
    fetch(`${apiUrl}/request/history`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        if (userType === "Tech" && techPro === "non" && ProTeam !== "oui") {
          // Filter for userType 'Tech'
          setHistory(
            data.filter(
              (item) => item.client_accept === sessionStorage.getItem("id")
            )
          );
        } else if (userType === "User") {
          // Filter for userType 'User'
          setHistory(
            data.filter(
              (item) => item.created_by === sessionStorage.getItem("id")
            )
          );
        } else if (userType === "Admin" || userType === "Superviseur") {
          // Show everything for 'Admin' or 'Superviseur'
          setHistory(data);
        } else if (userType === "Tech" && techPro === "oui") {
          setHistory(
            data.filter(
              (item) =>
                item.accepted_by.includes(sessionStorage.getItem("id")) &&
                item.client === "Pro"
            )
          );
        } else if (userType === "Tech" && ProTeam === "oui") {
          console.log("inside id", teamId);
          console.log("teamData[0].creator", creator);
          setHistory(
            data.filter(
              (item) =>
                item.accepted_by.includes(creator) &&
                item.client === "Pro" &&
                item.existingPlanning === "yes" &&
                item.TeamID === teamId
            )
          );
        }
      })
      .catch((error) => console.error(error));
  }, [userType, teamId, creator]);

  console.log("history fetched", history);
  // Include userType in the dependency array

  useEffect(() => {
    const fetchTeamData = async () => {
      try {
        const userId = sessionStorage.getItem("id");

        const response = await fetch(`${apiUrl}teams/find_teams`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
          body: JSON.stringify({}),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();

        // Filter the team data based on the current connected user's ID
        const filteredTeamData = data.filter((team) => {
          const lastTechnicienKey = `TechnicienEquipe[${
            Object.keys(team).filter((key) =>
              key.startsWith("TechnicienEquipe[")
            ).length - 1
          }]`;

          return team[lastTechnicienKey] === userId;
        });

        // Log the filtered team data after setting it to state
        setTeamData(filteredTeamData);
        setTeamID(filteredTeamData[0]._id);
        setCreator(filteredTeamData[0].created_by);
        console.log("Filtered Team Data:", filteredTeamData);
      } catch (error) {
        console.error("Error fetching team data:", error.message);
      }
    };

    fetchTeamData();
  }, []);

  console.log("Team Data:", teamData);
  console.log("Team ID", teamId);

  useEffect(() => {
    // Define the URL
    const apiUrl = `${apiUrl}/find`;

    // Send a GET request to the API
    fetch(apiUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((responseData) => {
        setUserData(responseData);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, []);

  const monthNames = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
  ];

const formatDate = (dateString) => {
  if (!dateString || dateString === "-") {
    console.log('Invalid date in formatDate:', dateString);
    return "-";
  }
  
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      console.log('Invalid Date object:', date);
      return "-";
    }

    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    const monthName = monthNames[monthIndex];

    return `${day} ${monthName} ${year}`;
  } catch (error) {
    console.error('Error in formatDate:', error);
    return "-";
  }
};

const getMonthYearFromDate = (dateInput) => {
  // Handle MongoDB date format {"$date": "ISO_STRING"}
  let dateString;
  if (dateInput && typeof dateInput === 'object' && dateInput.$date) {
    dateString = dateInput.$date;
  } else {
    dateString = dateInput;
  }

  if (!dateString || dateString === "-") {
    console.log('Invalid date input:', dateInput);
    return "";
  }

  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      console.log('Invalid Date object created from:', dateString);
      return "";
    }

    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${month} ${year}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return "";
  }
};

const isSameMonthAndYear = (dateInput, selectedMonthYear) => {
  if (!dateInput || !selectedMonthYear) return false;
  
  try {
    // Handle MongoDB date format
    const dateStr = dateInput && typeof dateInput === 'object' && dateInput.$date 
      ? dateInput.$date 
      : dateInput;
    
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return false;
    
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    const currentMonthYear = `${month} ${year}`;
    
    return currentMonthYear === selectedMonthYear;
  } catch (error) {
    console.error('Error in isSameMonthAndYear:', error);
    return false;
  }
};

  const info =
  
    history.length > 0
      ? userType === "Tech" && techPro === "oui"
        ? history
            .filter(
              (item) =>
                item.type !== "Demande de Réclamation" &&
                item.type !== "Demande de Maintenance"
            )
            .map((item) => {
              return {
                id: item._id,
                Création: new Date(item.created_at),
                FilterDate: item.created_at,
                Prestation:
                  item.typeDePrestation === "Autres"
                    ? "Remise en conformité"
                    : item.typeDePrestation,
                Client: item.nom + " " + item.prenom,
                Raison: item.raisonSocialClient,
                Produit: item.typeDeProjet,
                Departement: item.postale,
                Equipe: item.TeamName,
                Intervention: item.date_intervention
                  ? new Date(item.date_intervention)
                  : "-",
                userID: item.created_by,
                Statut: item.status,
              };
            })
            .sort((a, b) => b.Création - a.Création)
            .map((item) => {
              return {
                id: item.id,
                Création: formatDate(item.Création),
                FilterDate: item.FilterDate,
                Prestation: item.Prestation,
                "Client Pro": item.Raison,
                Client: item.Client,
                Departement: item.Departement,
                Equipe: item.Equipe,
                "Date intervention": formatDate(item.Intervention),
                userID: item.userID,
                Statut: item.Statut,
              };
            })
        : userType === "Tech" && ProTeam === "oui"
        ? history
            .filter(
              (item) =>
                item.type !== "Demande de Réclamation" &&
                item.type !== "Demande de Maintenance"
            )
            .map((item) => {
              return {
                id: item._id,
                Création: new Date(item.created_at),
                FilterDate: item.created_at,
                Prestation:
                  item.typeDePrestation === "Autres"
                    ? "Remise en conformité"
                    : item.typeDePrestation,
                Client: item.nom + " " + item.prenom,
                Raison: item.raisonSocialClient,
                Produit: item.typeDeProjet,
                Departement: item.postale ?? "-",
                Equipe: item.TeamName,
                Intervention: item.date_intervention
                  ? new Date(item.date_intervention)
                  : "-",
                userID: item.created_by,
                Statut: item.status,
              };
            })
            .sort((a, b) => b.Création - a.Création)
            .map((item) => {
              return {
                id: item.id,
                Création: formatDate(item.Création),
                FilterDate: item.FilterDate,
                Prestation: item.Prestation,
                "Client Pro": item.Raison,
                Client: item.Client,
                Departement: item.Departement ?? "-",
                Equipe: item.Equipe,
                "Date intervention": formatDate(item.Intervention),
                userID: item.userID,
                Statut: item.Statut,
              };
            })
        : userType === "User"
        ? history
            .filter(
              (item) =>
                item.type !== "Demande de Réclamation" &&
                item.type !== "Demande de Maintenance" &&
                item.created_by === sessionStorage.getItem("id")
            )
            .map((item) => {
              return {
                id: item._id,
                Création: new Date(item.created_at),
                userID: item.created_by,
                Type: item.type ? item.type : "-",
                Prestation:
                  item.typeDePrestation === "Autres"
                    ? "Remise en conformité"
                    : item.typeDePrestation,
                Domaine: item.typeDeProjet ? item.typeDeProjet : "-",
                Zone: ( item.zone || item.zone !== null || item.zone !== "null" ) ? item.zone : "-",
                Status: item.status ? item.status : "-",
              };
            })
            .sort((a, b) => b.Création - a.Création)
            .map((item) => {
              return {
                id: item.id,
                userID: item.userID,
                Création: formatDate(item.Création),
                Type: item.Type,
                Prestation: item.Prestation,
                "Type d'appareil": item.Domaine,
                Département: item.Zone && item.Zone !== "null" ? item.Zone : "-",
                Statut: item.Status,
              };
            })
        : history
            .filter(
              (item) =>
                item.type !== "Demande de Réclamation" &&
                item.type !== "Demande de Maintenance"
            )
            .map((item) => {
              return {
                id: item._id,
                userID: item.created_by,
                Création: new Date(item.created_at),
                Prestation:
                  item.typeDePrestation === "Autres"
                    ? "Remise en conformité"
                    : item.typeDePrestation,
                Client: item.nom + " " + item.prenom,
                Raison: item.raisonSocialClient,
                Produit: item.typeDeProjet,
                CP: item.postale,
                Statut: item.status,
              };
            })
            .sort((a, b) => b.Création - a.Création)
            .map((item) => {
              return {
                id: item.id,
                Création: formatDate(item.Création),
                userID: item.userID,
                Prestation: item.Prestation,
                "Client Pro": item.Raison,
                Client: item.Client,
                "Type d'appareil": item.Produit,
                "Code Postal": item.CP,
                Statut: item.Statut,
              };
            })
      : [];

const dateOptions = [
  { value: "", label: "Toutes les dates" },
  ...Array.from(
    new Set(
      info
        .map(item => getMonthYearFromDate(item.FilterDate))
        .filter(Boolean)
    )
  ).sort((a, b) => {
    // Sort dates in descending order (newest first)
    const [monthA, yearA] = a.split(' ');
    const [monthB, yearB] = b.split(' ');
    const monthIndexA = monthNames.indexOf(monthA);
    const monthIndexB = monthNames.indexOf(monthB);
    
    if (yearA !== yearB) {
      return parseInt(yearB) - parseInt(yearA);
    }
    return monthIndexB - monthIndexA;
  }).map(date => ({
    value: date,
    label: date
  }))
];

console.log('Final dateOptions:', dateOptions);

  return (
    <>
      {userType === "User" ? (
        <BreadCrumb
          From={"Compte"}
          To={"historique des interventions"}
          hrefFrom={"/tableau-de-bord"}
        />
      ) : userType === "Tech" && sessionStorage.getItem("TechPro") === "oui" ? (
        <BreadCrumb
          From={"Compte"}
          To={"historique des interventions"}
          hrefFrom={"/mon-compte-tech"}
        />
      ) : userType === "Tech" && ProTeam === "oui" ? (
        <BreadCrumb
          From={""}
          To={"historique des interventions"}
          hrefFrom={"/mon-compte-team-pro"}
        />
      ) : (
        <BreadCrumb
          From={""}
          To={"historique des interventions"}
          hrefFrom={"/recherche"}
        />
      )}

      <div className="flex gap-2 w-[90%] ml-auto mr-auto flex-wrap ">
        {(userType === "Admin" || userType === "Superviseur") && (
          <>
            <Select
              value={
                selectedClient
                  ? {
                      value: selectedClient,
                      label: users.find((user) => user._id === selectedClient)
                        ?.raisonSocial,
                    }
                  : null
              }
              onChange={(selectedOption) =>
                setSelectedClient(selectedOption ? selectedOption.value : "")
              }
              options={[
                // Add the "Toutes les entreprises" option
                { value: "", label: "Toutes les entreprises" },
                ...users.map((item) => ({
                  value: item._id,
                  label: item.raisonSocial,
                })),
              ]}
              placeholder="Toutes les entrerprise"
              className="mt-6 p-2 border border-gray-200 py-3 px-2 rounded-lg cursor-pointer bg-gray-50 w-60"
            />
          </>
        )}
        {userType === "Tech" && techPro === "oui" && (
          <>
            <Select
              value={
                selectedClient
                  ? {
                      value: selectedClient,
                      label: users.find((user) => user._id === selectedClient)
                        ?.raisonSocial,
                    }
                  : null
              }
              onChange={(selectedOption) =>
                setSelectedClient(selectedOption ? selectedOption.value : "")
              }
              options={[
                // Add the "Toutes les entreprises" option
                { value: "", label: "Toutes les entreprises" },
                ...users.map((item) => ({
                  value: item._id,
                  label: item.raisonSocial,
                })),
              ]}
              placeholder="Toutes les entrerprise"
              className="mt-6 p-2 border border-gray-200 py-3 px-2 rounded-lg cursor-pointer bg-gray-50 w-60"
            />

            <Select
              className="mt-6 p-2 border border-gray-200 py-3 px-2 rounded-lg cursor-pointer bg-gray-50 w-[280px]"
              isMulti
              value={selectedZone}
              onChange={(selectedOptions) => {
                if (
                  selectedOptions.some((option) => option.value === "all_zones")
                ) {
                  // If "Toutes les zones" is selected, reset the zone filter
                  setSelectedZone([]);
                } else {
                  // Update selected zones
                  setSelectedZone(selectedOptions);
                }
              }}
              options={[
                // Add the "Toutes les zones" option
                { value: "all_zones", label: "Toutes les départements" },
                ...Array.from(
                  new Set(info.map((item) => item.Departement))
                ).map((status) => ({
                  value: status,
                  label: status,
                })),
              ]}
              placeholder="Toutes les départements"
            />

            <Select
              className="mt-6 p-2 border border-gray-200 py-3 px-2 rounded-lg cursor-pointer bg-gray-50 w-60"
              isMulti
              value={selectedTeam}
              onChange={(selectedOptions) => setSelectedTeam(selectedOptions)}
              options={[
                // Add the "Toutes les équipes" option
                { value: "", label: "Toutes les équipes" },
                ...Array.from(new Set(info.map((item) => item.Equipe))).map(
                  (team) => ({
                    value: team,
                    label: team,
                  })
                ),
              ]}
              placeholder="Toutes les équipes"
            />
          </>
        )}

        {userType === "Tech" && ProTeam === "oui" && (
          <>
            <Select
              value={
                selectedClient
                  ? {
                      value: selectedClient,
                      label: users.find((user) => user._id === selectedClient)
                        ?.raisonSocial,
                    }
                  : null
              }
              onChange={(selectedOption) =>
                setSelectedClient(selectedOption ? selectedOption.value : "")
              }
              options={[
                // Add the "Toutes les entreprises" option
                { value: "", label: "Toutes les entreprises" },
                ...users.map((item) => ({
                  value: item._id,
                  label: item.raisonSocial,
                })),
              ]}
              placeholder="Toutes les entrerprise"
              className="mt-6 p-2 border border-gray-200 py-3 px-2 rounded-lg cursor-pointer bg-gray-50 w-60"
            />

            <Select
              className="mt-6 p-2 border border-gray-200 py-3 px-2 rounded-lg cursor-pointer bg-gray-50 w-[280px]"
              isMulti
              value={selectedZone}
              onChange={(selectedOptions) => {
                if (
                  selectedOptions.some((option) => option.value === "all_zones")
                ) {
                  // If "Toutes les zones" is selected, reset the zone filter
                  setSelectedZone([]);
                } else {
                  // Update selected zones
                  setSelectedZone(selectedOptions);
                }
              }}
              options={[
                // Add the "Toutes les zones" option
                { value: "all_zones", label: "Toutes les départements" },
                ...Array.from(
                  new Set(info.map((item) => item.Departement))
                ).map((status) => ({
                  value: status,
                  label: status,
                })),
              ]}
              placeholder="Toutes les départements"
            />

            <Select
              className="mt-6 p-2 border border-gray-200 py-3 px-2 rounded-lg cursor-pointer bg-gray-50 w-60"
              isMulti
              value={selectedTeam}
              onChange={(selectedOptions) => setSelectedTeam(selectedOptions)}
              options={[
                // Add the "Toutes les équipes" option
                { value: "", label: "Toutes les équipes" },
                ...Array.from(new Set(info.map((item) => item.Equipe))).map(
                  (team) => ({
                    value: team,
                    label: team,
                  })
                ),
              ]}
              placeholder="Toutes les équipes"
            />
          </>
        )}

        <Select
          value={
            selectedValue
              ? { label: selectedValue, value: selectedValue }
              : null
          }
          onChange={(selectedOption) =>
            setSelectedValue(selectedOption ? selectedOption.value : "")
          }
          options={dateOptions}
          className="mt-6 p-2 border border-gray-200 py-3 px-2 rounded-lg cursor-pointer bg-gray-50 w-60"
          placeholder="Toutes les dates"
        />
        {!(userType === "Tech" && techPro === "oui") && (
          <Select
            value={
              selectedStatus
                ? { label: selectedStatus, value: selectedStatus }
                : null
            }
            onChange={(selectedOption) =>
              setSelectedStatus(selectedOption ? selectedOption.value : "")
            }
            options={[
              {
                value: "",
                label: "Tous les statuts",
              },
              ...Array.from(new Set(info.map((item) => item.Statut))).map(
                (status) => ({
                  value: status,
                  label:
                    status === "Pending"
                      ? "En cours"
                      : status === "closed"
                      ? "Cloturé"
                      : status === "closed_tech"
                      ? "Cloturé par technicien"
                      : status === "claim"
                      ? "Réclamation"
                      : status === "Denied_payment"
                      ? "Devis non accepté"
                      : status === "Accepted_payment"
                      ? "Devis accepté"
                      : status === "Paymen_User"
                      ? "Devis"
                      : status === "Accepted"
                      ? "Accepté par client"
                      : status === "solved"
                      ? "Résolu"
                      : status === "unsolved"
                      ? "Non résolu"
                      : status === "Full"
                      ? "Complète"
                      : status === "claime_fixed"
                      ? "Réclamation résolu"
                      : status === "litige_fixed"
                      ? "Litige résolu"
                      : status === "annulled"
                      ? "Annulée"
                      : status === "Tech_onhold"
                      ? "En attente"
                      : status === "pending"
                      ? "En cours"
                      : status,
                })
              ),
            ]}
            className="mt-6 p-2 border border-gray-200 py-3 px-2 rounded-lg cursor-pointer bg-gray-50 w-60"
            placeholder="Tous les statuts"
          />
        )}
        {!(userType === "Tech" && ProTeam === "oui") && (
          <Select
            value={
              selectedStatus
                ? { label: selectedStatus, value: selectedStatus }
                : null
            }
            onChange={(selectedOption) =>
              setSelectedStatus(selectedOption ? selectedOption.value : "")
            }
            options={[
              {
                value: "",
                label: "Tous les statuts",
              },
              ...Array.from(new Set(info.map((item) => item.Statut))).map(
                (status) => ({
                  value: status,
                  label:
                    status === "Pending"
                      ? "En cours"
                      : status === "closed"
                      ? "Cloturé"
                      : status === "closed_tech"
                      ? "Cloturé par technicien"
                      : status === "claim"
                      ? "Réclamation"
                      : status === "Denied_payment"
                      ? "Devis non accepté"
                      : status === "Accepted_payment"
                      ? "Devis accepté"
                      : status === "Paymen_User"
                      ? "Devis"
                      : status === "Accepted"
                      ? "Accepté par client"
                      : status === "solved"
                      ? "Résolu"
                      : status === "unsolved"
                      ? "Non résolu"
                      : status === "Full"
                      ? "Complète"
                      : status === "claime_fixed"
                      ? "Réclamation résolu"
                      : status === "litige_fixed"
                      ? "Litige résolu"
                      : status === "annulled"
                      ? "Annulée"
                      : status === "Tech_onhold"
                      ? "En attente"
                      : status === "pending"
                      ? "En cours"
                      : status,
                })
              ),
            ]}
            className="mt-6 p-2 border border-gray-200 py-3 px-2 rounded-lg cursor-pointer bg-gray-50 w-60"
            placeholder="Tous les statuts"
          />
        )}
      </div>

      <div className="mt-10 max-w-screen-xl  ml-auto mr-auto">
        <CRUDTable
          data={info.filter((item) => {
            if (
              !selectedValue &&
              !selectedStatus &&
              !selectedClient &&
              !selectedZone &&
              !selectedTeam
            ) {
              return true;
            }

            return (
              (selectedClient ? item.userID === selectedClient : true) &&
              (selectedZone.length === 0
                ? true
                : selectedZone.some(
                    (selectedItem) => item.Departement === selectedItem.value
                  )) &&
              (selectedTeam.length === 0
                ? true
                : selectedTeam.some(
                    (selectedItem) => item.Equipe === selectedItem.value
                  )) &&
              (selectedValue
                ? isSameMonthAndYear(item.FilterDate, selectedValue)
                : true) &&
              (selectedStatus ? item.Statut === selectedStatus : true)
            );
          })}
          link={`/user-intervention-details/`}
          eyeIcon={
            <IoEyeOutline
              style={{ fontSize: "18px", cursor: "pointer", color: "#f8c408" }}
            />
          }
          onDataChange={handleDataChange}
        />s
      </div>
    </>
  );
};